<template>
    <div class="chart-container">
    <div v-if="size !== 'mini'" class="chart-legend-container" style="height: 50px;">
      <label v-for="(result, index) in clusterTargetResults" :key="result.name">
        <span class="chart-mark chart-mark-count"
          :style="{ backgroundColor: getGraphColor(index).borderColor }"></span>
        <span class="chart-legend-name">{{getLabel(result.name)}}</span>
      </label>
    </div>
    <div class="chart-main-container">
      <chart ref="chart" chartType="bar" chartId="ClusterTargetChart" :width="size === 'mini' ? 300 : 836"
             :height="size === 'mini' ? 180 : 400"></chart>
    </div>
  </div>
</template>

<script lang="js">
import ChartCmp from './base.vue'
import CommonUtil from '../../utils/common'
import FormatUtil from '../../utils/format'
import { GraphStackBarColorSets } from '../../defines/chart-color'

export default {
  name: 'ClusterTargetChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    clusterTargetComparison: {type: Object, default: () => {}},
    yName: '',
    categoryId: '',
    size: ''
  },
  data () {
    return {
      clusterTargetResults: this.clusterTargetComparison.results,
      yLabel: this.yName ? `${this.yName}の件数` : '件数',
      lineColors: GraphStackBarColorSets
    }
  },
  created () {
    const isMini = (this.size === 'mini')

    if (CommonUtil.isEmpty(this.clusterTargetResults)) return

    let labels = []
    let datasets = []

    this.clusterTargetResults.forEach((result, index) => {
      if (CommonUtil.isEmpty(labels)) {
        labels = result.value.map(row => this.getLabel(row.order))
      }

      let dataset = {
        label: result.name,
        data: result.value.map(row => row.count),
        yAxisID: 'count'
      }
      dataset = Object.assign(dataset, this.getGraphColor(index))
      datasets.push(dataset)
    })

    const chartData = {
      labels: labels,
      datasets: datasets
    }

    const options = {
      responsive: isMini,
      title: {
        display: false
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          id: 'count',
          position: 'left',
          scaleLabel: {
            display: !isMini,
            labelString: this.yLabel,
            fontSize: 16
          },
          stacked: true,
          ticks: {
            beginAtZero: false,
            major: {},
            minor: {},
            callback: function (value, index, values) {
              return CommonUtil.isEmpty(value) ? '' : `${FormatUtil.formatNumber(value)}`
            }
          }
        }],
        xAxes: [
          {
            display: !isMini,
            scaleLabel: {
              display: false
            },
            stacked: true,
            ticks: {
              maxRotation: 90
            }
          }
        ]
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            const datasetIndex = tooltipItem.datasetIndex
            let label = data.datasets[datasetIndex].label || ''
            const value = CommonUtil.isEmpty(tooltipItem.yLabel) ? '' : `${FormatUtil.formatNumber(tooltipItem.yLabel)}`

            return this.yName ? `${label}の件数: ${value}件` : `件数: ${value}件`
          }
        }
      }
    }

    this.$nextTick(() => {
      this.$refs.chart.renderChart(chartData, options)
      this.$forceUpdate()
    })
  },
  methods: {
    getGraphColor (index) {
      const colorIndex = index % this.lineColors.length
      return this.lineColors[colorIndex]
    },
    getLabel (rawData) {
      return rawData === 'all' ? '全データ' : rawData
    }
  }
}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
  }

  .chart-legend-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .chart-legend-container > label {
    display: flex;
    align-items: center;
  }

  .chart-mark {
    display: inline-block;
    width: 12px;
    height: 12px;
  }

  .chart-mark-count {
    background-color: #86C7F5;
    margin-right: 10px;
  }

  .chart-mark-y-avg {
    border-radius: 50%;
    margin-left: 10px;
  }

  .chart-legend-name {
    margin-right: 10px;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/cluster-target.vue